const tabledepreciation = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "leased_asset",
        name: "リース資産",
        editable: true
    },
    {
        key: "tangible_fixed_assets",
        name: "有形固定資産",
        editable: true
    },
    {
        key: "depreciation_expenses",
        name: "減価償却費",
        editable: true
    }
];

export { tabledepreciation };
